(function() {

  angular
	.module('meanApp')
	.controller('allergensCtrl', allergensCtrl);

  allergensCtrl.$inject = ['$location', 'allergensManager', 'Allergen', '$rootScope', 'alert', '$scope', 'confirmationModal'];
  function allergensCtrl($location, allergensManager, Allergen, $rootScope, alert, $scope, confirmationModal) {
	var vm = this;
	//console.log('the current user is ', $rootScope.currentUser);
	vm.allergens = {};

	$rootScope.$watch('currentUser', function () {
		if ($rootScope.currentUser) {
			if($rootScope.currentUser.role === 'admin'){
				loadAllergens();
			}
			else {
				$location.path('/');
			}
		}
	}, function(err) {
		console.log(err);
	});

	var loadAllergens = function() {
		allergensManager.getAll()
		.then(function(result) {
			vm.allergens = result.collection;
		}, function(err) {
			console.log('error loafing all allergens');
		});
	};

	vm.confirmationQuestion = 'Voulez vous vraiment supprimer cet allergène ?';
	vm.onConfirmationModalClick = function() {
		allergensManager.delete($scope.allergenIDToDelete)
		.then(function() {
			this.$close();
	  		alert.push('success', 'Cet allergène a été supprimé définitivement de la base de données');
	  	}.bind($scope), function() {
	  		this.$close();
	  		alert.push('danger', "Cet allergène n'a pas pu être supprimé");
	  	}.bind($scope));
	};
	
	vm.removeAllergen = function(id) {
		$scope.allergenIDToDelete = id;
		$scope.modalInstance = confirmationModal.open($scope, 'allergensCtrl');
	};

	vm.onAllergenSubmit = function() {
		if (typeof vm.id !== 'undefined' && vm.name) {
			var newAllergen = new Allergen({
				easyID: vm.id,
				name: vm.name
			});
			newAllergen.save()
			.then(function (allergen) {
				var instanceAllergen = allergensManager.set(allergen);
				vm.allergens.push(instanceAllergen);
				alert.push('success', 'Nouveau rayon ajouté en base de données');
			}, function (error) {
				//TOOD préciser si déja en base de données ou quoi
				alert.push('danger', 'Rayon non ajouté en base de données');
			});
		}
	};

  }

})();